import { Injectable } from "@angular/core";
import { DashboardHandlerService } from "../handlers/dashboard-handler.service";

@Injectable({
  providedIn: "root",
})
export class DashboardService {
  constructor(private DashboardHandlerService: DashboardHandlerService) {}

  getDashboard(masterAccountID: number, accountAppID: number) {
    return this.DashboardHandlerService.dashboardGet(
      masterAccountID,
      accountAppID,
    );
  }

  updateDashboard(
    masterAccountID: number,
    accountAppID: number,
    body: any,
    options?: any,
  ) {
    return this.DashboardHandlerService.dashboardPut(
      masterAccountID,
      accountAppID,
      body,
      options,
    );
  }

  createDashboard(
    masterAccountID: number,
    accountAppID: number,
    body: any,
    options?: any,
  ) {
    return this.DashboardHandlerService.dashboardPost(
      masterAccountID,
      accountAppID,
      body,
      options,
    );
  }

  getDeliveriesByCategories(
    masterAccountID: number,
    accountAppID: number,
    start: Date,
    end: Date,
  ) {
    return this.DashboardHandlerService.deliveriesByCategoryGet(
      masterAccountID,
      accountAppID,
      start,
      end,
    );
  }

  getInstalls(
    masterAccountID: number,
    accountAppID: number,
    start: Date,
    end: Date,
  ) {
    return this.DashboardHandlerService.installsGet(
      masterAccountID,
      accountAppID,
      start,
      end,
    );
  }

  getMobileLocationAllowed(
    masterAccountID: number,
    accountAppID: number,
    start: Date,
    end: Date,
  ) {
    return this.DashboardHandlerService.mobileLocationAllowedGet(
      masterAccountID,
      accountAppID,
      start,
      end,
    );
  }

  getRegionsSnapshot(
    masterAccountID: number,
    accountAppID: number,
    start: Date,
    end: Date,
  ) {
    return this.DashboardHandlerService.regionsSnapshotGet(
      masterAccountID,
      accountAppID,
      start,
      end,
    );
  }

  getOnProperty(masterAccountID: number, accountAppID: number) {
    return this.DashboardHandlerService.onPropertyGet(
      masterAccountID,
      accountAppID,
    );
  }

  getDeliveredContent(
    masterAccountID: number,
    accountAppID: number,
    start: Date,
    end: Date,
  ) {
    return this.DashboardHandlerService.deliveredContentGet(
      masterAccountID,
      accountAppID,
      start,
      end,
    );
  }

  getAssistantThreads(
    masterAccountID: number,
    accountAppID: number,
    integrationID: number,
    start: Date,
    end: Date,
  ) {
    return this.DashboardHandlerService.assistantThreadsGet(
      masterAccountID,
      accountAppID,
      integrationID,
      start,
      end,
    );
  }

  getAssistantDevicesUsers(
    masterAccountID: number,
    accountAppID: number,
    integrationID: number,
    start: Date,
    end: Date,
  ) {
    return this.DashboardHandlerService.assistantDevicesUsersGet(
      masterAccountID,
      accountAppID,
      integrationID,
      start,
      end,
    );
  }

  getAssistantSharesRatingsFeedback(
    masterAccountID: number,
    accountAppID: number,
    integrationID: number,
    start: Date,
    end: Date,
  ) {
    return this.DashboardHandlerService.assistantSharesRatingsFeedbackGet(
      masterAccountID,
      accountAppID,
      integrationID,
      start,
      end,
    );
  }
}
